import { Grid, Typography } from "@mui/material";
import { useSuperAdminSinglePlan } from "../../../context/SuperAdmin/SinglePlanContext";

const SinglePlanDescription = () => {
  const { plan } = useSuperAdminSinglePlan();
  return (
    <Grid
      container
      sx={{
        padding: 4,
        backgroundColor: "#EEF3F6",
        display: "grid",
        gridTemplateColumns: "repeat(2, 1fr)",
        width: 1,
        gap:2
      }}
    >
      <Grid item display={"flex"} gap={2}>
        <Typography fontSize={18} sx={{ fontWeight: 700 }}>Nombre:</Typography>
        <Typography fontSize={18}>{plan.nombre}</Typography>
      </Grid>

      <Grid item display={"flex"} gap={2}>
        <Typography fontSize={18} sx={{ fontWeight: 700 }}>Descripción:</Typography>
        <Typography fontSize={18}>{plan.descripcion}</Typography>
      </Grid>

      <Grid item display={"flex"} gap={2}>
        <Typography fontSize={18} sx={{ fontWeight: 700 }}>Créditos Mensuales:</Typography>
        <Typography fontSize={18}>{plan.creditos_mensuales}</Typography>
      </Grid>

      <Grid item display={"flex"} gap={2}>
        <Typography fontSize={18} sx={{ fontWeight: 700 }}>Duracion (meses):</Typography>
        <Typography fontSize={18}>{plan.duracion}</Typography>
      </Grid>

      <Grid item display={"flex"} gap={2}>
        <Typography fontSize={18} sx={{ fontWeight: 700 }}>Usuarios máx.:</Typography>
        <Typography fontSize={18}>{plan.max_usuarios}</Typography>
      </Grid>

      <Grid item display={"flex"} gap={2}>
        <Typography fontSize={18} sx={{ fontWeight: 700 }}>Precio (USD):</Typography>
        <Typography fontSize={18}>{plan.precio}</Typography>
      </Grid>

      <Grid item display={"flex"} gap={2}>
        <Typography fontSize={18} sx={{ fontWeight: 700 }}>Total créditos:</Typography>
        <Typography fontSize={18}>{plan.total_creditos}</Typography>
      </Grid>

      <Grid item display={"flex"} gap={2}>
        <Typography fontSize={18} sx={{ fontWeight: 700 }}>Estado:</Typography>
        <Typography fontSize={18}>{plan.estado}</Typography>
      </Grid>
    </Grid>
  );
};

export default SinglePlanDescription;
